export default "__VITE_ASSET__BXbH6W2O__"